import * as React from 'react';
export var headingSectiondepthContext = React.createContext(0);
